import { types, isType } from "mobx-state-tree"
export const PoolWager = types.model({
    _id: types.identifier,
    bytes32Id: types.string,
    eventId: types.string,
    maker: types.string,
    value: types.number,   
    makerChoice: types.number,  
    settled: types.boolean,
    cancelled: types.boolean,    
    isWinner: types.optional(types.boolean, false),
    isPropWager: types.optional(types.boolean, false),
    originalEventId: types.optional(types.string, ""),
    isPrivate: types.optional(types.boolean, false)
});


// WEBPACK FOOTER //
// ./src/models/PoolWager.js